var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 16.2199C13.7 16.8299 13.9423 17.4149 14.3736 17.8463C14.8049 18.2776 15.39 18.5199 16 18.5199C16.6099 18.5199 17.195 18.2776 17.6263 17.8463C18.0576 17.4149 18.3 16.8299 18.3 16.2199C18.3 15.6099 18.0576 15.0249 17.6263 14.5936C17.195 14.1622 16.6099 13.9199 16 13.9199C15.39 13.9199 14.8049 14.1622 14.3736 14.5936C13.9423 15.0249 13.7 15.6099 13.7 16.2199Z",
    fill: "#94959B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3536 15.5934C23.7236 15.9667 23.7236 16.5667 23.3536 16.9399C21.2782 19.0338 19.0911 20.5333 16 20.5333C12.9089 20.5333 10.7218 19.0338 8.64639 16.9399C8.27642 16.5667 8.27642 15.9667 8.64639 15.5934C10.7218 13.4996 12.9089 12 16 12C19.0911 12 21.2782 13.4996 23.3536 15.5934Z",
    stroke: "#94959B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisible);
export default __webpack_public_path__ + "static/media/ic_visible.67f2b3a1127d948b478624bab683f342.svg";
export { ForwardRef as ReactComponent };